<template>
  <sui-form>
    <sui-form-field class="required" v-bind:class="fieldClass('email')">
      <label>Email Address</label>
      <input
        placeholder="email"
        v-validate="'required'"
        name="email"
        type="email"
        v-model="teacher.Email"
        default=""
      />
      <span>{{ errors.first('email') }}</span>
    </sui-form-field>
    <sui-form-field
      v-if="user.profile.role === 'Administrator'"
      v-bind:class="fieldClass('requiresTraining')"
    >
      <label>Requires Training?</label>
      <input
        name="requiresTraining"
        type="checkbox"
        checked="true"
        v-model="teacher.RequiresTraining"
      />
      <span>{{ errors.first('requiresTraining') }}</span>
    </sui-form-field>
    <sui-form-field
      v-if="user.profile.role === 'Administrator'"
      v-bind:class="fieldClass('isTeacherAdmin')"
    >
      <label>Teacher Administrator?</label>
      <input
        name="isTeacherAdmin"
        type="checkbox"
        v-model="teacher.isTeacherAdmin"
      />
      <span>{{ errors.first('isTeacherAdmin') }}</span>
    </sui-form-field>
    <div v-if="error" class="ui negative message">
      <p>{{ error }}</p>
    </div>
    <sui-button type="button" positive icon="plus" v-on:click="submit">
      'Add'
    </sui-button>
  </sui-form>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  name: 'AddTeacherForm',
  props: ['teacher', 'error'],
  computed: mapGetters({
    user: 'user',
  }),
  methods: {
    reset() {
      this.$validator.reset();
    },
    fieldClass(name) {
      const result = [];
      if (this.errors.first(name)) {
        result.push('error');
      }
      return result;
    },
    submit() {
      this.$validator.validate().then((result) => {
        if (result) {
          this.$emit('saved');
        }
      });
    },
  },
  created() {},
};
</script>



// WEBPACK FOOTER //
// src/components/teachers/AddTeacherForm.vue